
<template>
  <div class="class-box elevation-2" style="position: relative;" @click="$router.push({name: 'classPos', params: { id: classData.id }})">
    <v-layout row wrap>
      <v-flex xs3 class="py-1">
        <span>{{ classData.course_code }}<strong>{{ classData.unit_code }}</strong>{{ classData.class_code }}</span>
      </v-flex>
      <v-flex xs3 class="py-1">
        <span><strong>{{ classData.unit_name }} - {{ classData.unit_code }}</strong></span>
      </v-flex>
      <!-- <v-flex xs4 class="pb-0">
        <span>SALA: <strong>{{ classData.room_pendency | checkPendency }}</strong></span>
      </v-flex> -->
      <!-- <v-flex xs4 class="pb-0">
        <span>DATA: <strong>{{ classData.day_pendency | checkPendency }}</strong></span>
      </v-flex> -->
      <!-- <v-flex xs4 class="pb-0">
        <span>TIPOS: <strong>{{ classData.course_type | courseType }}</strong></span>
      </v-flex> -->
      <!-- <v-flex xs4>
        <span>CADASTRO: <strong>{{ classData.created | convertDate }}</strong></span>
      </v-flex> -->
      <v-flex xs3 class="py-1">
        <span><strong>{{ classData.first_day | convertDateCheck }}</strong></span>
      </v-flex>
      <v-flex xs3 class="py-1">
        <span><strong>{{ classData.last_day | convertDateCheck }}</strong></span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['classData'],
  data() {
    return {

    }
  }
}
</script>

<style scoped>
  .class-box {
    border-left: solid 10px #c4161c;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    margin-bottom: 26px;
    cursor: pointer;
  }
</style>
